export function formatZipCode(zipCode: string): string {
  if (!zipCode) return "";

  const digits = zipCode.replace(/\D/g, "");

  if (digits.length !== 8) return "";

  return digits.replace(/(\d{5})(\d{3})/, "$1-$2");
}
